import React from "react";

import { numberFormat } from "./format";
import { pickMillions } from "./utils";
import OnePanelChart from "./OnePanelChart";
import Text from "./Text";

const Shares = ({
  constants,
  teams,
  competitionMetrics,
  preMoneys,
  equityCumulative,
  roundId,
}) => {
  // Issued shares: initial_shares at the start of this round plus the
  // cumulative shares issued across all rounds up to and including it.
  // pre_moneys[i].initial_shares is per-round; match on round so the
  // page reflects the round the user is viewing. If the lookup misses
  // (shouldn't, but defensive), fall back to constants.initial_shares.
  const preMoneyRow = Array.isArray(preMoneys)
    ? preMoneys.find(p => Number(p.round) === Number(roundId))
    : null;
  const initialShares = preMoneyRow && preMoneyRow.initial_shares != null
    ? Number(preMoneyRow.initial_shares)
    : Number(constants && constants.initial_shares) || 0;

  // equity_cumulative is a single-row array with totals-to-date.
  const cumRow = Array.isArray(equityCumulative) ? equityCumulative[0] : null;
  const sharesIssuedCumulative = cumRow && cumRow.shares_issued_cumulative != null
    ? Number(cumRow.shares_issued_cumulative)
    : 0;
  const sharesRepurchasedCumulative = cumRow && cumRow.shares_repurchased_cumulative != null
    ? Number(cumRow.shares_repurchased_cumulative)
    : 0;

  const issuedShares = initialShares + sharesIssuedCumulative;
  const repurchasedShares = sharesRepurchasedCumulative;
  const outstandingShares = issuedShares - repurchasedShares;

  return (
    <OnePanelChart
      title="Shares Issued & Outstanding"
      prefix=""
      suffix="M"
      data={pickMillions(teams, competitionMetrics, "Shares")}
      precision={0}
      teams={teams}
    >
      <Text>
        Your business is authorized to issue up to{" "}
        {numberFormat(constants["authorized_shares"])} shares. In this round,
        you did the following:
      </Text>
      <Text>
        Issued {numberFormat(issuedShares)} shares
      </Text>
      <Text>
        Repurchased {numberFormat(repurchasedShares)} shares
      </Text>
      <Text>
        This resulted in total outstanding shares of{" "}
        {numberFormat(outstandingShares)}.
      </Text>
    </OnePanelChart>
  );
};

export default Shares;



// WEBPACK FOOTER //
// ./src/components/analysis/Shares.js